export default __webpack_public_path__ + "static/DSC01544-c1684087b8e326364d3ec0fc0e88ad98.jpeg";